/* eslint-disable */
import { React, useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as DeleteIcon } from '../../../Assets/images/svg/dar_delete.svg';
import StarOfMonth from '../../../Assets/images/svg/starimg.svg';
import Appreciation from '../../../Assets/images/svg/thumbimg.svg';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';

const RecognitionItem = ({ recognition, monthNames, handleOpenDialog }) => {
  // Access user profile and permissions from AuthContext
  const { userProfile } = useContext(AuthContext);
  const permissions = userProfile?.permissions?.[MODULE_NAMES.EMPLOYEE_PROJECTS]|| [];

  const hasAccess = (action) => {
    return permissions.includes(action);
  };

  const getMonthYearFromDate = (date) => {
    const options = { month: 'long', year: 'numeric' };
    return new Date(date).toLocaleDateString('en-US', options);
  };
  
  let recognitionDate = '';

  if (recognition.client_name) {
    recognitionDate = getMonthYearFromDate(recognition.date);
  } else {
    if (recognition.month) {
      recognitionDate += `${monthNames[recognition.month - 1]} `;
    }
    if (recognition.year) {
      recognitionDate += recognition.year;
    }
  }

  return (
    <div className="recognition-item">
      <div className='recognition-item-content'>
      <div className="recognition-top-sec">
        <div className="recognition-head-section">
          <div className="recognition-logo-section">
            {recognition.recognition_type === 'Star of the month' ? (
              <img
                className="star-button"
                src={StarOfMonth}
                alt="star of the month"
              />
            ) : (
              <img
                className="appreciation-button"
                src={Appreciation}
                alt="Client appreciation"
              />
            )}
            <span className="star-of-the-month">
              {recognition.recognition_type}
            </span>
          </div>
          <div className="recognition-type-month">
            {recognition.client_name && (<p className='recognition-name'>{recognition.client_name}&nbsp;&nbsp;-&nbsp;&nbsp; </p>)}
            <p className="recognition-type-year">              
              {recognitionDate}
</p>
          </div>
        </div>
        {hasAccess('delete') && (
          <button onClick={() => handleOpenDialog(recognition)}>
            <DeleteIcon />
          </button>
        )}
      </div>
      <div>
        <p className='feedback'>{recognition.feedback}</p>
      </div>
      </div>
    </div>
  );
};

RecognitionItem.propTypes = {
  recognition: PropTypes.object.isRequired,
  monthNames: PropTypes.array.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
};

export default RecognitionItem;
